import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SafeHtmlPipe } from '@mwe/ui/pipes';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'ikp-terms-of-use-title',
  imports: [SafeHtmlPipe, TranslatePipe],
  templateUrl: './terms-of-use-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsOfUseTitleComponent {}
